import { css } from '@emotion/css';
import { actImageUrl, commonGenresStyle } from 'Shared/frontend/eventPosters/MusicPoster';
import { nameStyle, maxTextLines} from 'Shared/frontend/Poster';
import { combinedGenres } from 'Shared/common/Macros';
import { Show } from 'solid-js';
import { poster } from 'Shared/frontend/SettingsProvider';


export function TwoActs(P)
{
	const s = () => P.posterSettings;
	const theme = () => poster(s().theme,'twoActs');

	const posterStyle = () => css(theme().contents, {
		width: '100%',
	});

	const imageStyle = () => css(theme().img);

	const imageWrapStyle = () => css(theme().imageWrap,{
		display: 'block',
		width: 174,
		img: {
			display: 'block',
			width: '100%',
		},
	});

	const artist1ImageStyle = () => css(imageWrapStyle(),{	
		position: 'relative',
		zIndex: '1',
	});

	const artist2ImageStyle = () => css(imageWrapStyle(),{
		float: 'right',
		marginTop: '-10px',
	});

	const detailsStyle = () => css({
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: '93px', // pushes genres to bottom of poster
	});

	const eventNameArtistNameStyle = () => css({
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'center',
		alignContent: 'center',
		height: '-webkit-fill-available',
	});

	const eventNameStyle = () => css(nameStyle(), {
		padding: '.5em 0 .5em 0',
		width: '100%',
		...maxTextLines(3),
		fontSize: s().nameFontSize ?? theme().name.fontSize
	});

	const artistNameStyle = () => css(theme().artistNames, {
		fontSize: s().artistNamesFontSize ?? theme().artistNames.fontSize
	});

	const genresStyle = () => css(commonGenresStyle(), theme().genres,{
		whiteSpace: 'normal', // we're grouping data so needs to be overridden from commonGenreStyle
	});


	const hide = () => s()?.hide ?? [];

	return (
		<div class={posterStyle()}>
			<div class={artist1ImageStyle()}>
				<img class={imageStyle()} src={actImageUrl(P.lineup[0].image)} height={116} />
			</div>

			<div class={artist2ImageStyle()}>
				<img class={imageStyle()} src={actImageUrl(P.lineup[1].image)} height={116} />
			</div>

			<div style='clear:both' />

			<div class={detailsStyle()}>
				<div class={eventNameArtistNameStyle()}>
					<Show when={!hide().includes('name') && P.name}>
						<div class={eventNameStyle()}>{ P.name }</div>
					</Show>
					<Show when={!hide().includes('artistName')}>
						<div class={artistNameStyle()}>
							{P.lineup[0].name}
							{' & '}
							{P.lineup[1].name}
						</div>
					</Show>
				</div>
				<div class={genresStyle()}>
					<Show when={!hide().includes('artistGenres')}>
						{ combinedGenres(P.lineup) }
					</Show>
				</div>
			</div>
		</div>
	);
}

